import React, { Component } from 'react';

import styles from 'assets/jss/material-dashboard-pro-react/components/tableStyle';
import './_styles.scss';
import { makeStyles } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import Overlay from '../../components/Overlay/Overlay';
import SearchableTable from './SearchableTable';
import CustomRefinementList from './CustomRefinementList';
import { connect } from "react-redux";
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { TYPESENSE_KEY, TYPESENSE_COLLECTION, TYPESENSE_HOST } from '../../config';
import {
  PRODUCT_INCLUDE_FIELDS,
  pricingJoinFilter,
  withPricingHydration,
} from '../../utils/joinedPricing';

const nodes = [1,2,3,4,5].map((i) => {
  return {
    host: `ts-${i}.saucey-api2.com`,
    protocol: "https"
  }
})

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: TYPESENSE_KEY, // Be sure to use an API key that only allows search operations
    nearestNode: {
      host: TYPESENSE_HOST,
      protocol: "https"
    },
    nodes,
    cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
  },
  // The following parameters are directly passed to Typesense's search API endpoint.
  //  So you can pass any parameters supported by the search endpoint below.
  //  query_by is required.
  additionalSearchParameters: {
    query_by: "title,subtitle,description,categories,company",
    // Product fields only — pricing is fetched per page against the pricing
    // collection instead of being joined into every hit.
    include_fields: PRODUCT_INCLUDE_FIELDS,
  },
});
// Looks up the active store's pricing for each page of results and flattens it
// onto `{store_id}_price` style keys, so the table components don't need to
// know the collections were split.
const searchClient = withPricingHydration(
  typesenseInstantsearchAdapter.searchClient,
  typesenseInstantsearchAdapter.typesenseClient
);

import {
  InstantSearch,
  Configure,
  Pagination,
  connectSearchBox,
  connectStateResults
} from 'react-instantsearch-dom';
import { getRestrictedCategories } from '../../api';

class YourInventory extends Component {
  state = {
    loading: false,
    refresh: false,
    oosOnly: false,
    restrictedCategories: [],
    restrictedCategoriesLoading: true
  };

  componentDidMount() {
    // Check if activeStore is already available
    if (this.props.activeStore) {
      this.fetchRestrictedCategories();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if activeStore just became available OR if activeStore changed
    if ((!prevProps.activeStore && this.props.activeStore && this.state.restrictedCategoriesLoading) ||
        (prevProps.activeStore !== this.props.activeStore && this.props.activeStore)) {
      // Set loading state and fetch restricted categories for the new store
      this.setState({ restrictedCategoriesLoading: true }, () => {
        this.fetchRestrictedCategories();
      });
    }
  }

  async fetchRestrictedCategories() {
    try {
      const { activeStore } = this.props;
      console.log(`activeStore: ${activeStore}`);
      const response = await getRestrictedCategories(activeStore);
      const restrictedCategories = response.data || [];
      this.setState({ 
        restrictedCategories,
        restrictedCategoriesLoading: false 
      });
    } catch (error) {
      console.error('Failed to fetch restricted categories:', error);
      // Even if API fails, allow the component to continue with empty restricted list
      this.setState({ 
        restrictedCategories: [],
        restrictedCategoriesLoading: false 
      });
    }
  }

  render() {
    const { loading, refresh, oosOnly, restrictedCategories, restrictedCategoriesLoading } = this.state;
    const { classes, activeStore, showAllItems, recommended} = this.props;

    // Don't render InstantSearch until both activeStore and restricted categories are loaded
    if (restrictedCategoriesLoading || !activeStore) {
      return (
        <div>
          <Overlay
            rootClasses={classes.overlayRoot}
            containerClasses={classes.overlayContainer}
            type={'loading'}
            size={96}
          />
        </div>
      );
    }

    // Store pricing lives in the pricing collection now. Referencing the join
    // in filter_by narrows results to what this store carries, so the global
    // catalog view deliberately leaves it out and lets the per-page pricing
    // lookup fill in prices for the products the store does carry.
    const clauses = [];
    if (recommended) {
      clauses.push("(rec_user:>=0 || rec_similar:>=0 || rec_checkout:>= 0 || rec_fbt:>= 0 || top_picks:>0)");
    } else if (showAllItems) {
      clauses.push("recipe:false");
      if (oosOnly) {
        clauses.push(pricingJoinFilter(`store_id:=${activeStore}`, "qty:0"));
      }
    } else {
      const pricingConditions = [`store_id:=${activeStore}`, "price:>0"];
      if (oosOnly) {
        pricingConditions.push("qty:0");
      }
      clauses.push(pricingJoinFilter(...pricingConditions));
    }

    clauses.push("is_high_risk:false");

    if (restrictedCategories && restrictedCategories.length > 0) {
      let catNames = restrictedCategories.map(category => category.name || category);
      clauses.push(`default_category:!=[${catNames}]`, `categories:![${catNames}]`);
    }

    const filters = clauses.join(" && ");


    return (
      <div>
        <InstantSearch
          indexName={TYPESENSE_COLLECTION}
          searchClient={searchClient}
          refresh={refresh}
        >
          <Configure hitsPerPage={50} filters={filters} pricingStoreId={activeStore} />
          <DebouncedSearchBox showLoadingIndicator delay={500} />
          <CustomRefinementList attribute={'default_category'} searchable={true} limit={100} showAllItems={showAllItems} oosOnly={oosOnly} setOosOnly={(oosOnly) => {this.setState({oosOnly: oosOnly})}}/>
          <SearchableTable
            showAllItems={showAllItems}
            activeStore={activeStore}
          />
          <Pagination showLast={true} />

          <div>
            {loading && (
              <Overlay
                rootClasses={classes.overlayRoot}
                containerClasses={classes.overlayContainer}
                type={'loading'}
                size={96}
              />
            )}
            <LoadingIndicator />
          </div>

        </InstantSearch>
      </div>
    );
  }
}

class CustomSearchBox extends Component {
  timerId = null;

  state = {
    value: this.props.currentRefinement
  };

  onChangeDebounced = (event, immediate) => {
    const { refine, delay } = this.props;
    const value = event.currentTarget.value;

    clearTimeout(this.timerId);
    if(immediate){
      refine(value)
    }else{
      this.timerId = setTimeout(() => refine(value), delay);
    }
    this.setState(() => ({
      value
    }));
  };

  render() {
    const { value } = this.state;

    return (
      <div className='ais-SearchBox'>
        <form onSubmit={(e)=>{e.preventDefault(); return false;}} className='ais-SearchBox-form'>
          <input
            className='ais-SearchBox-input'
            value={value}
            onChange={this.onChangeDebounced}
            placeholder="Search for products..."
          />
          {!value ? <button type="submit" title="Submit your search query." className="ais-SearchBox-submit">
            <svg className="ais-SearchBox-submitIcon" xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                 viewBox="0 0 40 40">
              <path
                d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"></path>
            </svg>
          </button> :
          <button onClick={(e) => {e.stopPropagation(); e.preventDefault(); this.onChangeDebounced({currentTarget: {value: ""}}, true) }} type="reset" title="Clear the search query." className="ais-SearchBox-reset">
            <svg className="ais-SearchBox-resetIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="10"
                 height="10">
              <path
                d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path>
            </svg>
          </button>}
        </form>
      </div>

    );
  }
}

const useStyles = makeStyles(styles);
const LoadingIndicator = (connectStateResults(
  ({ isSearchStalled }) => {
    const classes = useStyles();
    return isSearchStalled ? <Overlay
      rootClasses={classes.overlayRoot}
      containerClasses={classes.overlayContainer}
      type={'loading'}
      size={96}
    /> : null}
));
const DebouncedSearchBox = connectSearchBox(CustomSearchBox)
export default connect(
  state => ({ activeStore: state.app.activeStore, activeStoreObject: state.app.activeStoreObject }),
  {}
)(withStyles(styles)(YourInventory));
